import { useEffect, useState } from "react";
import { MdDeleteOutline } from "react-icons/md";
import DeleteSubIdentitiesAliasesModal from "./DeleteSubIdentitiesAliasesModal/DeleteSubIdentitiesAliasesModal";
import SubIdentitiesAliasesModal from "./SubIdentitiesAliasesModal";
import { FormattedMessage, useIntl } from "react-intl";
import AliaseSubIdHistoryModal from "./AliaseSubIdHistory/AliaseSubIdHistoryModal";
import StaticTable from "../StaticTable/StaticTable";
import { LuArrowRightLeft, LuHistory, LuPlus } from "react-icons/lu";
import SubIdentitiesAliasesSwitcherModal from "./SubIdentitiesAliasesSwitcherModal/SubIdentitiesAliasesSwitcherModal";
import { useSelector } from "react-redux";
import Tooltip from "../Tooltip/Tooltip";

const SubIdentitiesAliases = ({ details, refresh, loading = false }) => {
  const intl = useIntl();
  const isEnableAlias = useSelector((state) => state.controller.isEnableAlias);
  const [iDData, setIDData] = useState();
  const [combinedTableData, setCombinedTableData] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteRowData, setDeleteRowData] = useState();
  const [aliasesOpen, setAliasesOpen] = useState(false);
  const [isaliasSubIdHistory, setaliasSubIdHistory] = useState(false);
  const [isUnsavedAliasesOpen, setIsUnsavedAliasesOpen] = useState(false);
  const [
    isSubIdentityAliasesSwitcherOpen,
    setIsSubIdentityAliasesSwitcherOpen,
  ] = useState(false);
  const [switcherRowData, setSwitcherRowData] = useState([]);
  const getSubIdentitiesAliases = () => {
    setCombinedTableData([]);
    try {
      setIDData({
        data_processing_authorizations: details?.data_processing_authorizations,
        digital_identity: details?.digital_identity,
      });
    } catch (error) {}
  };
  const handleSubIdentityAliasSubmit = (status, reload = false) => {
    if (reload && refresh) refresh();
    setAliasesOpen(status);
  };
  useEffect(() => {
    getSubIdentitiesAliases();
  }, [details]);
  useEffect(() => {
    const aliases = details?.digital_identity?.aliases?.map((alias) => ({
      ...alias,
      identity: "Alias",
    }));
    const subIds = details?.digital_identity?.sub_identities?.map((alias) => ({
      ...alias,
      identity: "Sub Identity",
    }));
    setCombinedTableData([...(aliases || []), ...(subIds || [])]);
  }, [details]);
  const columns = [
    {
      header: intl.formatMessage({
        id: "label.record-type",
        defaultMessage: "Record Type",
      }),
      accessorKey: "identity",
    },
    {
      header: intl.formatMessage({ id: "label.type", defaultMessage: "Type" }),
      accessorKey: "type",
    },
    {
      header: intl.formatMessage({
        id: "label.value",
        defaultMessage: "Value",
      }),
      accessorKey: "value",
    },
    {
      header: intl.formatMessage({
        id: "label.action",
        defaultMessage: "Action",
      }),
      accessorKey: "action",
      cell: ({ row }) => {
        const isAliasRow = row?.original?.identity === "Sub Identity";
        const isDisabled = isEnableAlias === false && isAliasRow;
        return (
          <div className="d-flex gap-4 justify-content-start align-items-center">
            <Tooltip
              position="right"
              text={
                <FormattedMessage
                  id="label.switcher"
                  defaultMessage={`Switch To ${row?.original?.identity === "Sub Identity" ? "Alias" : "Sub Identity"}`}
                  values={{
                    recordType:
                      row?.original?.identity === "Sub Identity"
                        ? "Alias"
                        : "Sub Identity",
                  }}
                />
              }
            >
              <button
                className={`btn m-0 p-0 ${isDisabled ? "border-0  not-allowed" : ""}`}
                onClick={() => {
                  if (isDisabled) return;
                  setIsSubIdentityAliasesSwitcherOpen(true);
                  setSwitcherRowData(row?.original);
                }}
              >
                <LuArrowRightLeft
                  className={`${isDisabled ? "text-secondary opacity-50 not-allowed" : "custom-theme-color"}  text-center `}
                  size={25}
                />
              </button>
            </Tooltip>
            <Tooltip
              position="right"
              text={
                <FormattedMessage
                  id="label.deleteIcon"
                  defaultMessage={`Delete this ${row?.original?.identity}`}
                />
              }
            >
              <button className="btn  m-0 p-0">
                <MdDeleteOutline
                  size={25}
                  className="text-danger text-center"
                  onClick={() => {
                    setDeleteOpen(true);
                    setDeleteRowData(row?.original);
                  }}
                />
              </button>
            </Tooltip>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 col-lg-12 px-0">
            <div className="custom-border">
              <div className="d-flex justify-content-end align-items-center search-bar-container px-3 py-2">
                <button
                  type="button"
                  className="btn btn-secondary mx-2 d-flex justify-content-center align-items-center px-3"
                  onClick={() => setaliasSubIdHistory(true)}
                >
                  <LuHistory size={22} />
                  <span className="px-1">
                    <FormattedMessage
                      id="label.history"
                      defaultMessage="History"
                    />
                  </span>
                </button>
                <button
                  type="button"
                  className="btn-primary d-flex justify-content-center align-items-center px-3"
                  onClick={() => setAliasesOpen(true)}
                >
                  <LuPlus size={22} />
                  <span className="px-1">
                    <FormattedMessage
                      id="label.create-new"
                      defaultMessage="Create New"
                    />
                  </span>
                </button>
              </div>
              <StaticTable
                columns={columns}
                data={combinedTableData}
                defaultErrorMessage={
                  "No SubIdentities/Aliases Present for this Person"
                }
                messageId={"id.sub-id-aliases.table.no-records"}
                loading={loading}
                clickableRow={false}
              />
              {isaliasSubIdHistory ? (
                <AliaseSubIdHistoryModal
                  open={isaliasSubIdHistory}
                  setOpen={setaliasSubIdHistory}
                  diData={details}
                  loading={loading}
                />
              ) : (
                <> </>
              )}
            </div>
          </div>
        </div>
      </div>
      <DeleteSubIdentitiesAliasesModal
        deleteOpen={deleteOpen}
        setDeleteOpen={setDeleteOpen}
        data={deleteRowData}
        getSubIdentitiesAliases={refresh}
      />
      <SubIdentitiesAliasesModal
        open={aliasesOpen}
        setOpen={handleSubIdentityAliasSubmit}
        idData={iDData}
        isUnsavedAliasesOpen={isUnsavedAliasesOpen}
        setIsUnsavedAliasesOpen={setIsUnsavedAliasesOpen}
      />
      <SubIdentitiesAliasesSwitcherModal
        open={isSubIdentityAliasesSwitcherOpen}
        setOpen={setIsSubIdentityAliasesSwitcherOpen}
        switcherRowData={switcherRowData}
        getSubIdentitiesAliases={refresh}
      />
    </>
  );
};

export default SubIdentitiesAliases;
